import "../../styles/scss/StatusChip.scss";

interface StatusChipProps {
  active: boolean;
}

export default function StatusChip({ active }: StatusChipProps) {
  return (
    <span className={`status-badge status-badge--${active ? 'active' : 'inactive'}`}>
      {active ? 'Active' : 'Inactive'}
    </span>
  );
}
